import * as turf from '@turf/turf';

// Группировка маркеров по полю `vetka`
export const groupMarkersByVetka = (switchesData) => {
    return switchesData.reduce((acc, coordinate) => {
      const vetka = coordinate.vetka;
      if (!acc[vetka]) acc[vetka] = [];
      acc[vetka].push(coordinate);
      return acc;
    }, {});
  };
  
  // Группировка маркеров по полю `canton`
  export const groupMarkersByCanton = (switchesData) => {
    return switchesData.reduce((acc, coordinate) => {
      const canton = coordinate.canton;
      if (!acc[canton]) acc[canton] = [];
      acc[canton].push(coordinate);
      return acc;
    }, {});
  };


// Функция для получения полигона по координатам
export const getPolygonPoints = (coordinates, bufferDistance = 20) => {
  const points = coordinates.map(coord => [parseFloat(coord.longitude), parseFloat(coord.latitude)]);
  const turfPoints = turf.points(points);

  // Получаем выпуклую оболочку
  const convexHull = turf.convex(turfPoints);
  
  if (convexHull) {
    // Расширяем полигон с использованием буфера
    const bufferedPolygon = turf.buffer(convexHull, bufferDistance, { units: 'meters' });

    // Возвращаем координаты расширенного полигона
    return bufferedPolygon.geometry.coordinates[0].map(coord => [coord[1], coord[0]]);
  }

  return null;
};


 // Группировка маркеров по полю `vetka`
//   const markersByVetka = switchesData.reduce((acc, coordinate) => {
//   // const markersByVetka = housesData.reduce((acc, coordinate) => {
//     const vetka = coordinate.vetka;
//     if (!acc[vetka]) acc[vetka] = [];
//     acc[vetka].push(coordinate);
//     return acc;
//   }, {});

//   // Группировка маркеров по полю `canton`
//   const markersByCanton = switchesData.reduce((acc, coordinate) => {
//  // const markersByCanton = housesData.reduce((acc, coordinate) => {
//     const canton = coordinate.canton;
//     if (!acc[canton]) acc[canton] = [];
//     acc[canton].push(coordinate);
//     return acc;
//   }, {});

  // const getPolygonPoints = (coordinates) => {
  //   const points = coordinates.map(coord => [parseFloat(coord.longitude), parseFloat(coord.latitude)]);
  //   const turfPoints = turf.points(points);
  //   const convexHull = turf.convex(turfPoints);
  //   if (convexHull) {
  //     return convexHull.geometry.coordinates[0].map(coord => [coord[1], coord[0]]);
  //   }
  //   return null;
  // };